import { Intervention, News } from '../types/contentTypes';

// Mock data for interventions
export const mockInterventions: Intervention[] = [
  {
    id: 'int-001',
    title: 'Požar gospodarskega poslopja',
    excerpt: 'Hitro posredovanje gasilcev je preprečilo širjenje požara na bližnje objekte.',
    content: `V soboto, 15. januarja 2025, ob 19:48 uri, je na območju Zgornje Polskave prišlo do požara gospodarskega poslopja. Ob prihodu na kraj dogodka so gasilci ugotovili, da je požar zajel celotno poslopje in da obstaja nevarnost širjenja na bližnje objekte.

Takoj po prihodu so pričeli z gašenjem požara, pri čemer so uporabili več gasilnih cevi in dihalne aparate. Zaradi intenzivnosti požara so bili na pomoč poklicani tudi gasilci iz sosednjih društev.

Po približno dveh urah intenzivnega gašenja so uspeli požar omejiti in preprečiti njegovo širjenje na bližnje stanovanjske objekte. Zaradi hitre intervencije ni bil nihče poškodovan, nastala pa je velika materialna škoda na gospodarskem poslopju.

Na intervenciji je sodelovalo 25 gasilcev s štirimi gasilskimi vozili. Vzrok požara še preiskujejo, po prvih ugotovitvah pa naj bi šlo za kratek stik v električni napeljavi.`,
    date: '2025-01-15',
    time: '19:48',
    location: 'Zgornja Polskava',
    image: '/images/interventions/int-001.jpg',
    category: 'fire',
    participants: 25
  },
  {
    id: 'int-002',
    title: 'Odstranjevanje podrtega drevesa',
    excerpt: 'Zaradi močnega vetra je prišlo do podrtja drevesa na cesto v naselju Zgornja Polskava.',
    content: `V četrtek, 28. februarja 2025, ob 14:23 uri, smo bili klicani na intervencijo odstranjevanja podrtega drevesa, ki je zaradi močnega vetra padlo na cesto v naselju Zgornja Polskava.

Gasilci smo na kraj prispeli v kratkem času in pričeli z odstranjevanjem drevesa, ki je oviralo promet. S pomočjo motorne žage smo drevo razžagali na manjše dele in ga odstranili s cestišča.

Intervencija je trajala približno eno uro, sodelovalo pa je 6 gasilcev z enim gasilskim vozilom. Po končani intervenciji je bil promet ponovno vzpostavljen brez omejitev.`,
    date: '2025-02-28',
    time: '14:23',
    location: 'Zgornja Polskava, Mladinska ulica',
    image: '/images/interventions/int-002.jpg',
    category: 'natural',
    participants: 6
  },
  {
    id: 'int-003',
    title: 'Črpanje vode iz poplavljene kleti',
    excerpt: 'Zaradi obilnega deževja je prišlo do poplave kleti stanovanjske hiše.',
    content: `V sredo, 3. marca 2025, ob 8:15 uri, smo bili obveščeni o poplavljeni kleti stanovanjske hiše v Zgornji Polskavi. Zaradi obilnega deževja v prejšnjih dneh je voda vdrla v kletne prostore in jih poplavila do višine približno 30 cm.

Po prihodu na kraj dogodka smo pričeli s črpanjem vode s pomočjo potopnih črpalk. Z intervencijo smo zaključili po približno dveh urah, ko smo uspešno izčrpali vso vodo iz kleti.

Na intervenciji je sodelovalo 5 gasilcev z enim gasilskim vozilom. Lastnikom smo svetovali tudi, kako preprečiti tovrstne težave v prihodnosti.`,
    date: '2025-03-03',
    time: '08:15',
    location: 'Zgornja Polskava, Špindlerjeva ulica',
    image: '/images/interventions/int-003.jpg',
    category: 'technical',
    participants: 5
  },
  {
    id: 'int-004',
    title: 'Gašenje travniškega požara',
    excerpt: 'Hitro ukrepanje je preprečilo širjenje požara na bližnji gozd.',
    content: `V ponedeljek, 17. aprila 2025, ob 16:42 uri, smo bili obveščeni o požaru na travniku v bližini Zgornje Polskave. Požar je zajel približno 1000 kvadratnih metrov travnate površine, obstajala pa je nevarnost širjenja na bližnji gozd.

Na mesto požara smo prispeli z dvema gasilskima voziloma in pričeli z gašenjem. Zaradi ugodnih vremenskih razmer smo požar uspešno omejili in pogasili v približno 45 minutah.

Na intervenciji je sodelovalo 12 gasilcev. Vzrok požara je bil odmet cigaretnega ogorka ob cesti.`,
    date: '2025-04-17',
    time: '16:42',
    location: 'Zgornja Polskava, ob regionalni cesti',
    image: '/images/interventions/int-004.jpg',
    category: 'fire',
    participants: 12
  }
];

// Mock data for news
export const mockNews: News[] = [
  {
    id: 'news-001',
    title: 'Uspešno izvedena gasilska vaja na osnovni šoli',
    excerpt: 'Izvedli smo gasilsko vajo evakuacije v sodelovanju z Osnovno šolo Zgornja Polskava.',
    content: `V petek, 15. marca 2025, smo v sodelovanju z Osnovno šolo Zgornja Polskava izvedli gasilsko vajo evakuacije. Namen vaje je bil preveriti pripravljenost učencev in zaposlenih v primeru požara ter predstaviti delo gasilcev.

Vaja se je začela z aktivacijo požarnega alarma, nato pa je sledila evakuacija vseh učencev in zaposlenih iz šolske stavbe. Evakuacija je potekala brez zapletov, vsi udeleženci so zapustili stavbo v predvidenem času in se zbrali na zbirnem mestu.

Po evakuaciji smo gasilci prikazali gašenje začetnega požara in reševanje ponesrečenca iz stavbe. Učencem smo predstavili tudi gasilsko opremo in vozila ter jim pokazali, kako se uporabljajo različni gasilni aparati.

Vaja je bila uspešno izvedena in je pokazala dobro pripravljenost šole na morebitno izredno situacijo. S takšnimi vajami želimo med mladimi širiti zavedanje o pomenu požarne varnosti in jih seznaniti z delom gasilcev.`,
    date: '2025-03-15',
    image: '/images/news/news-001.jpg',
    category: 'training'
  },
  {
    id: 'news-002',
    title: 'Pridobitev nove gasilske opreme',
    excerpt: 'Naše društvo je prejelo novo opremo za tehnično reševanje.',
    content: `Z veseljem sporočamo, da je naše gasilsko društvo prejelo novo opremo za tehnično reševanje, ki bo pomembno pripomogla k še učinkovitejšemu delu naših operativnih gasilcev.

Nova oprema vključuje hidravlično orodje za reševanje iz vozil, ki omogoča hitrejše in varnejše reševanje ukleščenih oseb. Oprema je bila nabavljena s pomočjo sredstev Občine Slovenska Bistrica in donacij podjetij ter posameznikov.

V naslednjih tednih bomo organizirali več vaj, na katerih se bodo naši člani seznanili z uporabo nove opreme in vadili različne scenarije reševanja.

Zahvaljujemo se vsem, ki so prispevali k nakupu te pomembne opreme, ki bo pripomogla k večji varnosti občanov v našem okolišu.`,
    date: '2025-02-28',
    image: '/images/news/news-002.jpg',
    category: 'announcement'
  },
  {
    id: 'news-003',
    title: 'Vabilo na gasilsko veselico',
    excerpt: 'Vabimo vas na tradicionalno gasilsko veselico, ki bo potekala 15. junija 2025.',
    content: `Prostovoljno gasilsko društvo Zgornja Polskava vas vabi na tradicionalno gasilsko veselico, ki bo potekala v soboto, 15. junija 2025, od 18. ure dalje pri gasilskem domu v Zgornji Polskavi.

Za zabavo in dobro voljo bo poskrbel ansambel Veseli gasilci, na voljo bo bogata gostinska ponudba z jedmi z žara in domačimi dobrotami. Manjkala ne bo niti srečelovna z bogatimi nagradami.

Dogodek bo potekal v vsakem vremenu, saj bomo v primeru dežja poskrbeli za pokrit prireditveni prostor.

Vabljeni vsi ljubitelji dobre glasbe, hrane in druženja, da se nam pridružite na tem tradicionalnem dogodku. S svojim obiskom boste podprli delovanje našega društva, saj bodo vsa zbrana sredstva namenjena za nakup nove gasilske opreme.`,
    date: '2025-05-20',
    image: '/images/news/news-003.jpg',
    category: 'event'
  },
  {
    id: 'news-004',
    title: 'Tekmovanje mladinskih ekip',
    excerpt: 'Naše mladinske ekipe so se odlično odrezale na regijskem tekmovanju.',
    content: `V soboto, 12. aprila 2025, so se naše mladinske ekipe udeležile regijskega gasilskega tekmovanja, ki je potekalo v Slovenski Bistrici. Na tekmovanju so se pomerili v različnih gasilskih disciplinah, kot so vaja z vedrovko, štafeta s prenosom vode in vaja razvrščanja.

Z velikim ponosom sporočamo, da so naše ekipe dosegle izjemne rezultate. Ekipa pionirjev je zasedla prvo mesto, ekipa mladincev drugo mesto, ekipa pionirk pa tretje mesto v svojih kategorijah.

Vsem tekmovalcem iskreno čestitamo za dosežene rezultate, ki so plod marljivega dela in rednih vaj. Zahvaljujemo se tudi mentorjem, ki skrbijo za usposabljanje in motivacijo naših mladih gasilcev.

S takšnimi rezultati se ekipe uvrščajo na državno tekmovanje, ki bo potekalo jeseni. Do takrat bomo nadaljevali z vajami in se pripravili, da bomo tudi tam dosegli čim boljše rezultate.`,
    date: '2025-04-12',
    image: '/images/news/news-004.jpg',
    category: 'event'
  }
];